//import api_patho_opd_job_worklist from "@/api/api_patho_opd_job_worklist";
import {  getBaseURLforBackEnd , getConfigAxios , myTimeZone}  from '@/utils.js'
import axios from "axios";
import master_data from "./master_data";
import moment from 'moment-timezone' 



export default {
    namespaced: true,

    state: {
        pathoMonthInvManagerArr: [],
        dateInvManagerWant : null,



        // prepare Inv. 
        dateInvPrepareWant : null,
        dateInvPrepareLoaded : null,
        opdParamsForSearchPrepareWant : null,
        memberIDParamsForSearchPrepareWant : null,
        radioSearchParamsPrepareWant : 0 , // 0 --> OPD No, 1 --> Member ID  
        usedPartResultSearch : [],


        // 
        memberIDParamsForMakeInvPrepareWant : null,  
        rowsPrepareToInvoice : [] ,




    },

    getters: {
    
    },

    mutations: {
         
        // Manager
        setPathoMonthInvManagerArr (state, pathoMonthInvManagerArr) {
            state.pathoMonthInvManagerArr = pathoMonthInvManagerArr
        },


        setDateInvManagerWant (state, dateInvManagerWant) {
            state.dateInvManagerWant = dateInvManagerWant
        },

        setDateInvPrepareLoaded (state, dateInvPrepareLoaded) {
            state.dateInvPrepareLoaded = dateInvPrepareLoaded
        },

         


        // Prepare
        setDateInvPrepareWant (state, dateInvPrepareWant) {
            state.dateInvPrepareWant = dateInvPrepareWant
        },
        setOPDParamsForSearchPrepareWant (state, opdParamsForSearchPrepareWant) {
            state.opdParamsForSearchPrepareWant = opdParamsForSearchPrepareWant
        },
        setMemberIDParamsForSearchPrepareWant (state, memberIDParamsForSearchPrepareWant) {
            state.memberIDParamsForSearchPrepareWant = memberIDParamsForSearchPrepareWant
        },
        setUsedPartResultSearch (state, usedPartResultSearch) {
            state.usedPartResultSearch = usedPartResultSearch
        },
        setRadioSearchParamsPrepareWant(state, radioSearchParamsPrepareWant) {
            state.radioSearchParamsPrepareWant = radioSearchParamsPrepareWant
        },
        setMemberIDParamsForMakeInvPrepareWant(state, memberIDParamsForMakeInvPrepareWant) {
            state.memberIDParamsForMakeInvPrepareWant = memberIDParamsForMakeInvPrepareWant
        },
        setRowsPrepareToInvoice(state, rowsPrepareToInvoice) {
            state.rowsPrepareToInvoice = rowsPrepareToInvoice
        }, 
         
  
         


    },

    actions: {
 

        fetchPathoMonthInvManager({commit,state}) {
            return new Promise((resolve) => {
                const datTo ={
                    "date_want" :    moment.tz(  state.dateInvManagerWant , myTimeZone).format('YYYY-MM-DD') +'T'+'00:00:00.000Z'  
                }
                // console.log(JSON.stringify(datTo))
                axios.defaults.headers.common['Authorization'] =  `Bearer ${master_data.state.access_token}`
                axios.post(`${getBaseURLforBackEnd()}/api/load_invoice_of_pathoservices_from_month_year`,datTo,getConfigAxios())
                    .then((res)=>{
                        // console.log(res.data)
                        commit('setPathoMonthInvManagerArr', res.data)
                        commit('setDateInvPrepareLoaded', state.dateInvManagerWant) 
                        resolve(res.data)
                    })
            })

        }, 


        fetchUsedPartPathoFromMonthYear({commit,state}) {
            return new Promise((resolve) => {
              
                const datTo ={
                    "date_want" :    moment.tz(  state.dateInvPrepareWant , myTimeZone).format('YYYY-MM-DD') +'T'+'00:00:00.000Z'  ,
                    "opd_no" : (state.opdParamsForSearchPrepareWant != null)&&(state.radioSearchParamsPrepareWant==0) ? state.opdParamsForSearchPrepareWant.idopd : null ,
                    "member_id" :  (state.memberIDParamsForSearchPrepareWant  != null) &&(state.radioSearchParamsPrepareWant==1) ? state.memberIDParamsForSearchPrepareWant.member_id : null
                }

                // console.log(JSON.stringify(datTo))
                console.log("fetchUsedPartPathoFromMonthYear") 


                axios.defaults.headers.common['Authorization'] =  `Bearer ${master_data.state.access_token}`
                axios.post(`${getBaseURLforBackEnd()}/api/get_detail_usedpartpatho_from_month_year`,datTo,getConfigAxios())
                    .then((res)=>{
                        commit('setUsedPartResultSearch', res.data)
                        resolve(res.data)
                    })
            })

        }, 

 


 

      


        
        

   


    }
}